import React, {useState, useEffect} from 'react';
import {useParams, useNavigate} from 'react-router-dom';
import {fetchFile, getCourseById} from '../apiConfig/services';
import {
    ChevronLeft,
    PictureAsPdfRounded
} from '@mui/icons-material';
import BookDetailShimmer from "./loading/BookDetailShimmer";

function BookDetail() {
    const {bookId} = useParams();
    const [book, setBook] = useState(null);
    const [coverUrl, setCoverUrl] = useState('');
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchBookDetails = async () => {
            setLoading(true);
            try {
                const bookData = await getCourseById(bookId);
                if (bookData) {
                    setBook(bookData);
                    if (bookData.cover_course) {
                        const cover = await fetchFile(bookData.cover_course, 'couverture');
                        setCoverUrl(cover || '');
                    }
                }
                setLoading(false);
            } catch (error) {
                console.error('Error fetching book details', error);
                setLoading(false);
            }
        };

        fetchBookDetails();
    }, [bookId]);

    const handleBackClick = () => {
        navigate(-1);
    };

    const handleViewPdf = (file, type_fiche) => {
        fetchFile(file, type_fiche).then(ficheUrl => {
            window.open(ficheUrl, '_blank');
        });
    };

    if (loading) {
        return <BookDetailShimmer/>;
    }

    if (!book) {
        return (
            <div className="flex justify-center items-center h-screen">
                <p className="text-red-500 text-xl">Error loading book details</p>
            </div>
        );
    }

    return (
        <div className=" bg-gray-50">
            <div className="container mx-auto px-4 py-8 lg:px-[5%]">
                {/* Back Button */}
                <button
                    onClick={handleBackClick}
                    className="mb-6 flex items-center text-primary hover:text-primary-dark transition-colors duration-300"
                >
                    <ChevronLeft className="mr-2"/>
                    Retour
                </button>

                {/* Book Header with Background */}
                <div
                    className="relative rounded-xl overflow-hidden shadow-lg mb-8 h-[350px] md:h-[400px] flex flex-col justify-end"
                    style={{
                        backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0.1), rgba(0,0,0,0.7)), url(${coverUrl})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        backgroundSize: 'cover',
                    }}
                >
                    <div className="p-6 text-white z-10">
                        <p className="text-sm mb-2 opacity-75">{book.name_category}</p>
                        <h1 className="text-2xl md:text-3xl font-bold mb-4">{book.title_course}</h1>
                        <p className="text-base">
                            <span className="font-semibold">Auteur:</span> {book.author_course}
                        </p>
                    </div>
                </div>

                {/* Description Section */}
                {book.resume_course && book.resume_course !== '-' && book.resume_course !== ' - ' && (
                    <div className="bg-white rounded-lg p-6 mb-8 shadow-sm">
                        <h2 className="text-xl font-semibold text-gray-800 mb-4 border-b pb-2">
                            Résumé
                        </h2>
                        <p className="text-gray-700 leading-relaxed">
                            {book.resume_course || "Aucun résumé disponible."}
                        </p>
                    </div>
                )}


                {/* Attached Files Section */}
                <div className="bg-white rounded-lg p-6 mb-4 shadow-sm">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4 border-b pb-2">
                        Fichiers Attachés
                    </h2>
                    {book.documents && book.documents.length > 0 ? (
                        <ul className="space-y-3 max-h-64 overflow-y-auto">
                            {book.documents.map((fiche) => (
                                <li
                                    key={fiche.id_document}
                                    className="flex items-center hover:bg-gray-50 p-2 rounded-md transition-colors"
                                >
                                    <PictureAsPdfRounded className="text-red-400 mr-3"/>
                                    <button
                                        onClick={() => handleViewPdf(fiche.path_document, fiche.typeFiche)}
                                        className="text-primary hover:underline text-left"
                                    >
                                        {fiche.titleFiche || "Fichier sans titre"}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p className="text-gray-500">Aucun fichier attaché</p>
                    )}
                </div>

                {Array.isArray(book.links) && book.links.length > 0 && (
                    <div className="bg-white rounded-lg p-6 shadow-sm">
                        <h2 className="text-xl font-semibold text-gray-800 mb-4 border-b pb-2">
                            Liens Externes
                        </h2>
                        <ul className="space-y-3 max-h-64 overflow-y-auto">
                            {book.links.map((lien) => (
                                <li
                                    key={lien.id_link}
                                    className="flex items-center hover:bg-gray-50 p-2 rounded-md transition-colors"
                                >
                                    <a
                                        href={lien.url_link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-blue-600 hover:underline cursor-pointer"
                                    >
                                        {lien.url_link}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                )
                }

            </div>
        </div>
    )
        ;
}

export default BookDetail;